var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"appup-link",attrs:{"id":_vm.id,"href":"#","variant":_vm.linkVarient,"disabled":_vm.disabled,"title":_vm.tooltip},on:{"click":_vm.onLinkClick}},[(_vm.icon)?[_c('icon',{attrs:{"name":_vm.icon}})]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.label)+"\n")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/link/link.vue